import HttpClient from './HttpClient';
import HttpClientError from './HttpClientError';

export default class HttpClientFile extends HttpClient {
  async _checkStatus(response) {
    let _response = await super._checkStatus(response);
    // If request a json file, but returned html
    // throw as 404 error, because default html file returned instead of requesting file
    if (
      _response.url.endsWith('.json')
      && _response.headers.get('content-type').includes('text/html')
    ) {
      _response = {
        status: 404,
        ok: false,
        statusText: 'Not Found',
        url: _response.url,
        type: _response.type,
        data: _response.data,
      };
      throw new HttpClientError(_response);
    }
    return _response;
  }

  _getOptions(options, requestData) {
    const opts = super._getOptions(options, requestData);
    delete opts.headers.Authorization;
    return opts;
  }
}
